import {EuiDescribedFormGroup, EuiFieldNumber, EuiFieldText, EuiFormRow, EuiLink, EuiRadioGroup,} from "@elastic/eui";
import {useField, useFormikContext} from "formik";
import {observer} from "mobx-react-lite";
import React, {Fragment, useContext, useEffect, useState} from "react";
import {Exchange} from "../../../app/models/exchange-types";
import {Store} from "../../../app/stores/store-root";
import {toJS} from "mobx";
import {allTransferTypes, bankOnlyTrasnferType} from "../../../app/stores/store-lookups.";

type CurrencyExchangeTypeProps={
    readonly? :boolean
}
const CurrencyExchangeType = ({readonly}:CurrencyExchangeTypeProps) => {
    const store = useContext(Store);
    const [currenyExchange, setCurrenyExchange] = useState<Exchange>();
    const [feesBasedOrder, setIsFeeBasedOrder] = useState(false);
    const [allowedExchanges, setAllowedExchanges]=useState([]);
    const formik = useFormikContext();

    const [exchangeTypeField, exchangeTypeFieldMeta, exchangeTypeFieldHelpers] = useField(
        "ExchangeType"
    );
    const [sendingCurrencyCodeField, m2, sendingCurrencyCodeFieldHelpers] = useField(
        "SendingCurrencyCode"
    );
    const [sendingCurrencyLabelField, m3, sendingCurrencyLabelFieldHelpers] = useField(
        "SendingCurrencyLabel"
    );
    const [sendingCurrencySymbolField, m4, sendingCurrencySymbolFieldHelpers] = useField(
        "SendingCurrencySymbol"
    );
    const [sendingAmountField, sendingAmountFieldMeta, sendingAmountFieldHelpers] = useField(
        "SendingAmount"
    );

    const [feesField, feesFieldMeta, feesFieldHelpers] = useField(
        "Fees"
    );

    const [exchangeRateField, m6, exchangeRateFieldHelpers] = useField(
        "ExchangeRate"
    );

    const [receivingCurrencyCodeField, m7, receivingCurrencyCodeFieldHelpers] = useField(
        "ReceivingCurrencyCode"
    );
    const [receivingCurrencyLabelField, _m8, receivingCurrencyLabelFieldHelpers] = useField(
        "ReceivingCurrencyLabel"
    );
    const [receivingCurrencySymbolField, m9, receivingCurrencySymbolFieldHelpers] = useField(
        "ReceivingCurrencySymbol"
    );
    const [receivingAmountField, receivingAmountFieldMeta, receivingAmountFieldHelpers] = useField(
        "ReceivingAmount"
    );


    //initialize fields
    const [from, setFrom] = useState<number>(0)
    const [to, setTo] = useState<number>(0)
    const [rate, setRate] = useState<number | undefined>(undefined)
    const [fees, setfees] = useState<number | undefined>(undefined)
    const [selectedCurrencyExchangeId, setSelectedCurrencyExchangeId] = useState("");


    useEffect(() => {
        setFrom(sendingAmountField.value);
        setRate(exchangeRateField.value);
        setTo(receivingAmountField.value);
        setSelectedCurrencyExchangeId(exchangeTypeField.value);
        const found: Exchange = store.Exchanges.exchangesRegitery.get(exchangeTypeField.value);
        if (found) {
            setCurrenyExchange(found);
            setIsFeeBasedOrder(found.FromCode === found.ToCode);
        }
        setfees(feesField.value);
    })

    useEffect(()=>{
    })

    const onChange = (id: string) => {
        const found: Exchange = store.Exchanges.exchangesRegitery.get(id);
        if (found) {
            console.log(JSON.stringify(found));
            setCurrenyExchange(found);
            setSelectedCurrencyExchangeId(id);
            exchangeTypeFieldHelpers.setValue(id);

            exchangeRateFieldHelpers.setValue(found.ExchangeRate);

            sendingCurrencyCodeFieldHelpers.setValue(found.FromCode);
            sendingCurrencyLabelFieldHelpers.setValue(found.From);
            sendingCurrencySymbolFieldHelpers.setValue(found.FromSymbol)


            receivingCurrencyCodeFieldHelpers.setValue(found.ToCode);
            receivingCurrencyLabelFieldHelpers.setValue(found.To);
            receivingCurrencySymbolFieldHelpers.setValue(found.ToSymbol);
            formik.getFieldHelpers('AgencyRate').setValue(found.AgencyRate);


            setIsFeeBasedOrder(found.FromCode === found.ToCode);

            if(found.FromCode === found.ToCode){
                store.Lookups.setTransferTypes(bankOnlyTrasnferType);
            }
            else {
                store.Lookups.setTransferTypes(allTransferTypes);
            }
        }
    };

    const onFromChange = (e: any) => {
        const sending = parseFloat(e.target.value);
        let receiving: number | undefined = undefined;
        if (feesBasedOrder)
            receiving = sending
        else
            receiving = sending * rate!;


        //updating local state
        setFrom(e.target.value)
        setTo(receiving)

        //Updating Formik fields
        sendingAmountFieldHelpers.setValue(parseFloat(e.target.value));
        receivingAmountFieldHelpers.setValue(parseFloat(receiving.toFixed(2)));
    }

    return (
        <Fragment>
            <EuiDescribedFormGroup
                title={<h3>Currency exchange</h3>}
                description={
                    <Fragment>
                        Please only select the currency that is agreed with the admin, and check if the rates have changed!
                    </Fragment>
                }
            >
                <EuiFormRow label="Currency exchanges avilable to you"
                            isInvalid={(exchangeTypeFieldMeta.error && exchangeTypeFieldMeta.touched) ? true : false}
                            error={exchangeTypeFieldMeta.error}>
                    <EuiRadioGroup
                        {...exchangeTypeField}
                        name='currencies'
                        options={store.Exchanges.exchangesAllowedForCurrentUser}
                        onChange={(id) => onChange(id)}
                        idSelected={selectedCurrencyExchangeId}
                        disabled = {readonly}
                    />
                </EuiFormRow>

                {currenyExchange ? (
                    <div className=''>
                        <EuiFormRow label='Sending amount'
                                    isInvalid={(sendingAmountFieldMeta.error && sendingAmountFieldMeta.touched) ? true : false}
                                    error={sendingAmountFieldMeta.error}>
                            <EuiFieldNumber
                                placeholder={`Sending amount in ${currenyExchange.FromSymbol}`}
                                id='SendingAmount'
                                data-test-subj='SendingAmount'
                                prepend={currenyExchange?.FromCode}
                                onChange={onFromChange}
                                append={currenyExchange.FromSymbol}
                                isInvalid={(sendingAmountFieldMeta.error && sendingAmountFieldMeta.touched) ? true : false}
                                value={from}
                                disabled = {readonly}
                            />
                        </EuiFormRow>

                        {(feesBasedOrder) ? (
                                (store.Users.isReceiveAgent) ? '' : (<EuiFormRow label='Fees (Set by Sending Agent)'
                                                                                 isInvalid={(formik.getFieldMeta('Fees').error && formik.getFieldMeta('Fees').touched) ? true : false}
                                                                                 error={formik.getFieldMeta('Fees').error}>
                                    <EuiFieldNumber
                                        {...formik.getFieldProps('Fees')}
                                        isInvalid={(formik.getFieldMeta('Fees').error && formik.getFieldMeta('Fees').touched) ? true : false}
                                    />
                                </EuiFormRow>)) :
                            (<EuiFormRow label='Exchange Rate (Set by Admin) '>
                                <EuiFieldText
                                    placeholder="String & text in a tooltip"
                                    value={currenyExchange?.ExchangeRate}
                                    disabled
                                    readOnly
                                />
                            </EuiFormRow>)}

                        <EuiFormRow label='Receiving amount (read only)'
                                    isInvalid={(receivingAmountFieldMeta.error && receivingAmountFieldMeta.touched) ? true : false}
                                    error={receivingAmountFieldMeta.error}>
                            <EuiFieldNumber
                                {...formik.getFieldProps('ReceivingAmount')}
                                placeholder={`Receiving amount in ${currenyExchange.ToSymbol}`}
                                prepend={currenyExchange?.ToCode}
                                //onChange={onToChange}
                                append={currenyExchange.ToSymbol}
                                readOnly
                                disabled = {readonly}
                                isInvalid={(receivingAmountFieldMeta.error && receivingAmountFieldMeta.touched) ? true : false}
                            />
                        </EuiFormRow>
                    </div>

                ) : (
                    ""
                )}
            </EuiDescribedFormGroup>
        </Fragment>
    );
};

export default observer(CurrencyExchangeType);
